import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

export const useServiceWorker = () => {
  const [needRefresh, setNeedRefresh] = useState(false);
  const [updateSW, setUpdateSW] = useState(null);

  useEffect(() => {
    const updateServiceWorker = registerSW({
      onNeedRefresh() {
        console.log('🔄 New content available, updating...');
        // Auto-update without asking user
        updateServiceWorker?.(true);
      },
      onOfflineReady() {
        console.log('✅ App ready for offline use');
      },
      onRegistered(registration) {
        console.log('✅ Service Worker registered');
        
        // Check for updates every 60 seconds
        if (registration) {
          setInterval(() => {
            console.log('🔍 Checking for updates...');
            registration.update();
          }, 60 * 1000);
        }
      },
      onRegisterError(error) {
        console.error('❌ Service Worker registration error:', error);
      },
      // Force immediate update
      immediate: true
    });

    setUpdateSW(() => updateServiceWorker);
  }, []);

  const forceUpdate = () => {
    if (updateSW) {
      updateSW(true);
    }
  };

  return { needRefresh, forceUpdate };
};

export default useServiceWorker;